module.exports = __webpack_public_path__ + "img/vip.c5407585.png";